import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { DriversCompaignComponent } from 'app/components/home/drivers/drivers-compaign/drivers-compaign.component';
import { ExportFileTypeEnum } from 'app/models';
import { RiderService } from 'app/services';
import { MessageService } from 'primeng/api';
import moment from 'moment';
import { Utils } from 'app/utils';
import { MenuHomeEnum } from 'app/components/home';
import { ExportQueryTypeEnum } from 'app/models/enums/export-query-type.enum';

enum DataFieldEnum {
    FirstName = 1,
    LastName = 2,
    MobileNumber = 3,
    Date = 4,
    AcceptanceRate = 5,
    CancellationRate = 6,
    NumberOfTransactions = 7,
    StartRiderOnline = 8,
    EndRiderOnline = 9,
    PickedUp = 10,
    DroppedOff = 11
}

@Component({
    selector: 'drivers-compaign-export-sidebar',
    templateUrl: './drivers-compaign-export-sidebar.component.html',
    styleUrls: ['./drivers-compaign-export-sidebar.component.scss']
})
export class DriversCompaignExportSidebarComponent implements OnInit {
    @Input()
    public menuHome!: MenuHomeEnum;

    @Input()
    public showDriversCompaignExportSidebar: boolean = false;

    @Input()
    public selectedDateRange: Date[] = [];

    @Input()
    public driverVehicleTypes: any[] = [];

    @Input()
    public exportHeaderColumns: string[] = [];

    @Input()
    public exportDataColumns: string[] = [];

    @Input()
    public driverCampaign: any = null;

    @Input()
    public driverServiceTypes: any[] = [];

    @Output() changedShowDriversCompaignExportSidebarEmit = new EventEmitter<boolean>();
    changedShowDriversCompaignExportSidebar(increased: any) {
        this.changedShowDriversCompaignExportSidebarEmit.emit(increased);
    }

    public dataFieldEnum = DataFieldEnum;
    public fileTypes: any = [
        {
            name: 'CSV', value: ExportFileTypeEnum.CSV
        },
        {
            name: 'Excel', value: ExportFileTypeEnum.Excel
        },
        {
            name: 'PDF', value: ExportFileTypeEnum.PDF
        },
    ];

    public exportData: any = {};
    public selectedDataFields: DataFieldEnum[] = [];

    public loading: boolean = false;

    constructor(private messageService: MessageService, private riderService: RiderService) { }

    ngOnInit(): void {
    }

    public clickDownload() {
        if (!this.exportData.fileType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select file type' });
            return;
        }
        const dto = {
            DataType: this.menuHome,
            ServiceTypes: this.driverServiceTypes,
            VehicleTypes: this.driverVehicleTypes,
            FileType: this.exportData.fileType,
            DriverCampaign: this.driverCampaign,
            ExportDataFields: this.selectedDataFields,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            HeaderColumns: this.exportHeaderColumns,
            DataColumns: this.exportDataColumns,
        };
        switch (this.menuHome) {
            case MenuHomeEnum.ActiveDrivers:
                this.exportRiders(dto, ExportQueryTypeEnum.ExportActiveRiders);
                break;
            case MenuHomeEnum.CompaignDrivers:
            case MenuHomeEnum.Xpress50Riders4W:
            case MenuHomeEnum.CompaignXpress50Drivers:
                const compaignDto = {
                    ...dto,
                    StartDate: moment(this.selectedDateRange[0]).format('YYYY-MM-DDTHH:mm:ss'),
                    EndDate: moment(this.selectedDateRange[1]).format('YYYY-MM-DDTHH:mm:ss'),
                    DriverCampaignType: this.driverCampaign
                };
                this.exportRiders(compaignDto, ExportQueryTypeEnum.ExportCampaignRiders);
                break;
            default: break;
        }
    }

    public exportRiders(dto: any, exportQueryType: ExportQueryTypeEnum) {
        this.loading = true;
        let query = new Promise(() => {});
        switch (exportQueryType) {
            case ExportQueryTypeEnum.ExportActiveRiders: query = this.riderService.exportActiveRiders(dto, this.messageService); break;
            case ExportQueryTypeEnum.ExportCampaignRiders: query = this.riderService.exportCompaignRiders(dto, this.messageService); break;
        }

        query.then(data => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Success' });
                Utils.saveFileResponse(data, 'Riders-' + new Date().valueOf(), this.exportData.fileType);
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    cancel() {
        this.changedShowDriversCompaignExportSidebar(false);
    }
}
